import React, {ReactElement, useEffect, useState} from 'react';
import {useAppDispatch, useAppSelector} from '../redux/hooks';
import CouponGIF from '../assets/json/Coupan.json';
import Lottie from 'react-lottie';
import {useHistory} from 'react-router';
import {loaderType} from '../redux/applyCouponSlice';
import {
  getAccessToken,
  getMetadata,
  getStartTime,
} from '../core/localstorage-data';
import {logout} from '../core/utils/routing.util';
import ConfirmModal from '../components/modal/ConfirmModal';
import {sessionTimeHandler} from '../lib/sessionTimeHandler';
import {
  newAccessToken,
  refreshNewToken,
  refreshTokenError,
  refreshTokenLoading,
  resetState,
} from '../redux/refreshTokenSlice';
import {getMoengage} from '../core/utils/moengage.util';

type RootContainerProps = {
  children: React.ReactNode;
};
let count = 0;
interface ActivityIndicatorProps {
  isVisible: boolean;
  isLoading: boolean;
  type: string;
}

const ActivityIndicator: React.FC<ActivityIndicatorProps> = ({
  isVisible = false,
  isLoading = false,
  type = '',
}: ActivityIndicatorProps): ReactElement | null => {
  const couponGif = {
    loop: true,
    autoplay: true,
    animationData: CouponGIF,
    rendererSettings: {
      // preserveAspectRatio: "xMidYMid slice"
    },
  };
  function renderLoader() {
    if (type === 'CouponGIFLoader') {
      return (
        <div
          className="flex backdrop-filter bg-blue_three absolute top-0 left-0 right-0 bottom-0"
          style={{zIndex: 100}}>
          <div className="self-center flex-1">
            <div>
              <Lottie options={couponGif} />
              <div
                className="absolute bottom-72 z-50 text-center font-roboto font-medium text-xl"
                style={{left: '5%', right: '5%', bottom: '41%'}}>
                <div>Calculating your coupon discount…</div>
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="flex backdrop-filter bg-black opacity-75 absolute z-50 top-0 left-0 right-0 bottom-0">
          <div className="self-center flex-1">
            <svg className="animate-spin h-7 w-7 mx-auto" viewBox="0 0 24 24">
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="white"
                strokeWidth="4"></circle>
              <path
                className="opacity-75"
                fill="white"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
          </div>
        </div>
      );
    }
  }
  return isVisible || isLoading ? renderLoader() : null;
};

const RootContainer: React.FC<RootContainerProps> = ({
  children,
}: RootContainerProps): ReactElement => {
  const isActivityRunning = useAppSelector(
    state => state.globalReducer.isActivityRunning,
  );
  const loaderRunning = useAppSelector(
    state => state.globalReducer.loaderRunning,
  );
  const [showSessionModal, setShowSessionModal] = useState(false);
  const [sessionfuncHandler, setSessionfuncHandler] = useState(false);
  const dispatch = useAppDispatch();
  const newTokenData = useAppSelector(refreshNewToken);
  const newTokenError = useAppSelector(refreshTokenError);
  const newTokenLoaded = useAppSelector(refreshTokenLoading);
  // const callMoengage = moenData();
  // callMoengage();
  const modalCloseHandler = () => {
    setShowSessionModal(false);
  };
  useEffect(() => {
    if (newTokenData != '') {
      const accessToken = newTokenData.toString();
      sessionTimeHandler(accessToken);
      dispatch(resetState);
    }
    if (newTokenError != '') {
      //todo in future
    }
  }, [newTokenData, newTokenError, newTokenLoaded]);

  let timeInterval1 = 0;
  const modalConfirmHandler = () => {
    const currentAccessToken = getAccessToken();
    if (currentAccessToken != null) {
      //console.log(currentAccessToken);
      dispatch(newAccessToken(currentAccessToken));
      setShowSessionModal(false);
      setSessionfuncHandler(true);
    }

    //console.log("Confirm modal");
    //diaspatch
  };
  let diffSec = 0;
  const checkSessionTime = (): string => {
    const pathname = useHistory().location.pathname;
    if (
      pathname === '/login' ||
      pathname === '/splash' ||
      pathname === '/qrcode'
    ) {
      return '';
    } else {
      timeInterval1 = window.setInterval(() => {
        const time = getStartTime();
        if (time != null) {
          const metaData = getMetadata();
          const SessionRemainingMetaData = metaData.find(
            (obj: {name: string}) => obj.name === 'session-remaining',
          );
          const TotalSessionMetaData = metaData.find(
            (obj: {name: string}) => obj.name === 'total-session-timeout',
          );
          const sessionTime = new Date(time).getTime();
          const currentTime = new Date().getTime();
          const timeDiff = currentTime - sessionTime;
          diffSec = Math.floor(timeDiff / 1000);
          if (diffSec === SessionRemainingMetaData) {
            setShowSessionModal(true);
            diffSec = 0;
            clearInterval(timeInterval1);
            return;
          }
          if (diffSec === TotalSessionMetaData) {
            logout();
            //console.log("hello shubham");
          }
        }
      }, 1000);
      return '';
    }
  };
  count = getMoengage(count);
  // callmoengage();
  const loaderTypeValue =
    useAppSelector(state => state.orderReducer.loaderType) || 'type-default';

  return (
    <div
      className={`container mx-auto root_container relative h-full `}
      data-testid="rootContainer">
      <div>{checkSessionTime()}</div>
      {showSessionModal ? (
        <div>
          <ConfirmModal
            title="Session Expire"
            message={`Do you want to continue session?`}
            onClose={modalCloseHandler}
            open={true}
            onCancel={modalCloseHandler}
            onConfirm={modalConfirmHandler}
          />
        </div>
      ) : (
        ''
      )}
      <ActivityIndicator
        isVisible={isActivityRunning}
        isLoading={loaderRunning}
        type={loaderTypeValue}
      />
      {children}
    </div>
  );
};

export default RootContainer;
